// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderLogo_root__gzBzc"};